module.exports = __webpack_public_path__ + "img/nemo.84e46525.png";